/**
 * Shared analytics events the MeshProvider fires via the in-package
 * `capture()` helper. Defined here so the shared provider does not depend
 * on app-local event taxonomies.
 */
export var MeshEvents;
(function (MeshEvents) {
    MeshEvents["MESH_LINK_OPENED"] = "mesh_link_opened";
    MeshEvents["MESH_LINK_CLOSED"] = "mesh_link_closed";
    MeshEvents["MESH_CONNECTION_SUCCESS"] = "mesh_connection_success";
    MeshEvents["MESH_CONNECTION_FAILED"] = "mesh_connection_failed";
    MeshEvents["MESH_ACCOUNT_UNLINKED"] = "mesh_account_unlinked";
    MeshEvents["MESH_TRANSFER_INITIATED"] = "mesh_transfer_initiated";
    MeshEvents["MESH_TRANSFER_COMPLETED"] = "mesh_transfer_completed";
    MeshEvents["MESH_TRANSFER_FAILED"] = "mesh_transfer_failed";
})(MeshEvents || (MeshEvents = {}));
